<template>
  <div class="footer">
    <div
      :class="
        sidebar && windowWidth > mobileWidth
          ? 'footer__info sidebar-padding'
          : 'footer__info'
      "
    >
      <div class="settings">
        <div class="darkMode">
          <label style="display: block">Dark Mode</label>
          <b-switch
            @input="changeTheme"
            class="darkModeSwitch"
            v-model="isdarkMode"
          ></b-switch>
        </div>
        <div class="locale-switcher">
          <label>{{ $t("language") }}</label>
          <b-select
            class="language-switch"
            @input="changeLocale($event)"
            v-model="$i18n.locale"
          >
            <option value="en">English</option>
            <option value="de">Deutsch</option>
          </b-select>
        </div>
      </div>
      <a class="contact" @click="goTo('/contact')">{{
        $t("footer.contact")
      }}</a>
      <a class="read-terms" @click="goTo('/terms')">{{ $t("footer.terms") }}</a>
      <a class="privacy" @click="goTo('/privacypolicy')">{{
        $t("footer.privacyPolicy")
      }}</a>
      <a class="cookies" @click="goTo('/cookiespolicy')">{{
        $t("footer.cookiePolicy")
      }}</a>
      <span class="copyright">© 2023 Pascal Babey</span>
    </div>
  </div>
</template>

<script>
import { goTo } from "../mixins/goTo.js";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Footer",
  mixins: [goTo],
  data: () => {
    return {
      mobileWidth: process.env.VUE_APP_MOBILE_WIDTH,
      isdarkMode: false
    };
  },
  computed: {
    ...mapGetters(["darkMode"])
  },
  props: {
    sidebar: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations(["setDarkMode", "setLocale"]),
    changeLocale(language) {
      localStorage.setItem("appLanguage", language);
    },
    changeTheme(value) {
      this.setDarkMode(value);

      window.location.reload();
    }
  },
  created() {
    this.isdarkMode = this.darkMode;
  }
};
</script>
